import React, { useEffect, useState } from "react";
import Sidebar from './Components/Sidebar/Sidebar'
import MaterialTable from "material-table";
import 'material-icons/iconfont/material-icons.css';
import NuevoPrestamo from '../pages/nuevoPrestamo'
import db from '../firebase-config'
import { collection, getDocs, doc, deleteDoc } from "firebase/firestore";

const localizacion = {
  header: { actions: 'Acciones' },
  body: {
    editRow: { deleteText: '¿Estás seguro de que quieres borrarlo?' },
    deleteTooltip: 'Borrar',
    emptyDataSourceMessage: 'No hay préstamos registrados',
  },
  pagination: {
    labelRowsSelect: 'filas',
    labelDisplayedRows: '{from}-{to} de {count}',
    firstTooltip: 'Primera página',
    previousTooltip: 'Página anterior',
    nextTooltip: 'Siguiente página',
    lastTooltip: 'Última página',
  },
  toolbar: {
    searchPlaceholder: 'Buscar...',
    exportTitle: 'Exportar',
    showColumnsTitle: 'Columnas',
  },
};

function Prestamos() {
  const [tab, setTab] = useState('activos');
  const [activos, setActivos] = useState([]);
  const [liquidados, setLiquidados] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const obtenerDatos = async () => {
      setLoading(true);
      try {
        const datos = await getDocs(collection(db, 'prestamos'));
        if (cancelled) return;

        const listActivos = [];
        const listLiquidados = [];

        datos.forEach(documento => {
          const data = documento.data();
          const obj = {
            id: documento.id,
            Pagos: data.Pagos,
            PagosStatus: data.PagosStatus,
            activo: data.activo,
            cantidadPrestada: data.cantidadPrestada,
            cantidadinteres: data.cantidadinteres,
            deudor: data.deudor,
            fechaContrato: data.fechaContrato,
            fechaLiquidacion: data.fechaLiquidacion,
            interes: data.interes,
          };
          if (data.activo) listActivos.push(obj);
          else listLiquidados.push(obj);
        });

        setActivos(listActivos);
        setLiquidados(listLiquidados);
      } catch (err) {
        console.error('Error al cargar préstamos:', err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    obtenerDatos();
    return () => { cancelled = true; };
  }, []);

  const columnasActivos = [
    { title: 'Deudor',               field: 'deudor' },
    { title: 'Fecha de contrato',    field: 'fechaContrato',    type: 'date' },
    { title: 'Fecha de vencimiento', field: 'fechaLiquidacion', type: 'date' },
    { title: 'Cantidad prestada',    field: 'cantidadPrestada', type: 'numeric' },
    { title: 'Interés %',            field: 'interes',          type: 'numeric' },
  ];

  const columnasLiquidados = [
    { title: 'Deudor',               field: 'deudor' },
    { title: 'Fecha de liquidación', field: 'fechaLiquidacion', type: 'date' },
    { title: 'Cantidad prestada',    field: 'cantidadPrestada', type: 'numeric' },
    { title: 'Interés %',            field: 'interes',          type: 'numeric' },
  ];

  async function deletePrestamo(row) {
    try {
      await deleteDoc(doc(db, "prestamos", row.id));
      setActivos(prev => prev.filter(p => p.id !== row.id));
    } catch (e) {
      console.error("Error al borrar préstamo:", e);
    }
  }

  const label = (key, texto) =>
    `${texto}${!loading && key !== 'nuevo' ? ` (${key === 'activos' ? activos.length : liquidados.length})` : ''}`;

  return (
    <div className="wrapper">
      <nav>
        <Sidebar />
      </nav>
      <div className="marg">
        <h1>Administrar préstamos</h1>

        <div className="custom-tabs">
          <div className="custom-tabs-nav">
            {['nuevo', 'activos', 'liquidados'].map(key => (
              <button
                key={key}
                className={tab === key ? 'active' : ''}
                onClick={() => setTab(key)}
              >
                {label(key, key === 'nuevo' ? 'Nuevo préstamo' : key === 'activos' ? 'Activos' : 'Liquidados')}
              </button>
            ))}
          </div>

          {tab === 'nuevo' && <NuevoPrestamo />}

          {tab === 'activos' && (
            <MaterialTable
              columns={columnasActivos}
              data={activos}
              title="Préstamos activos"
              isLoading={loading}
              options={{
                actionsColumnIndex: -1,
                exportButton: true,
                pageSize: 10,
                pageSizeOptions: [10, 25, 50],
                loadingType: 'linear',
              }}
              localization={localizacion}
              editable={{
                onRowDelete: selectedRow => new Promise(resolve => {
                  deletePrestamo(selectedRow).then(resolve);
                }),
              }}
            />
          )}

          {tab === 'liquidados' && (
            <MaterialTable
              columns={columnasLiquidados}
              data={liquidados}
              title="Préstamos liquidados"
              isLoading={loading}
              options={{
                actionsColumnIndex: -1,
                exportButton: true,
                pageSize: 10,
                pageSizeOptions: [10, 25, 50],
                loadingType: 'linear',
              }}
              localization={localizacion}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default Prestamos;
